module.exports = __webpack_public_path__ + "static/img/function2.54ab001e.png";